<button class="option" (click)="handleClick()" [ngClass]="{ active: isActive }">
  <p class="optionText">{{ text }}</p>
</button>
